<template>
  <div>
    <seckill-list v-show="tabType === 1" @handleShow="handleShow" />
    <seckill-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import seckillList from './list.vue'
import seckillShow from './show.vue'
export default {
  components: { seckillList, seckillShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>